import { render, staticRenderFns } from "./UserOfficerDetail.vue?vue&type=template&id=55a275ca&scoped=true"
import script from "./UserOfficerDetail.vue?vue&type=script&lang=js"
export * from "./UserOfficerDetail.vue?vue&type=script&lang=js"
import style0 from "./UserOfficerDetail.vue?vue&type=style&index=0&id=55a275ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a275ca",
  null
  
)

export default component.exports